import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    voucher_waitingList_subtitle: 'Лист ожидании',
    voucher_waitingList_requestFormId: '№ Заявления',
    voucher_waitingList_voucherId: '№ Ваучера',
    voucher_waitingList_childIIN: 'ИИН ребенка',
    voucher_waitingList_childFIO: 'ФИО ребенка',
    voucher_waitingList_childBirthday: 'Дата рождения',
    voucher_waitingList_DOName: 'Наименование ДО',
    voucher_waitingList_address: 'Адрес',
    voucher_applications_changeDDO: 'Изменить ДО',
    voucher_waitingList_enroll: 'Зачислить в ДО',
    voucher_waitingList_interested: 'Заинтересован',
    voucher_waitingList_position: '№ Очереди',
    voucher_waitingList_deadlineDateForEnroll:'Срок зачисления в ДО',


    voucher_waitingList_errorLoad: 'Ошибка при загрузке данных',
    voucher_waitingList_error_add_waiting_list: 'Не удалось добавить в лист ожидания',
    voucher_waitingList_error_change_waiting_list: 'Не удалось изменить ДО'
  },
  kk: {
    voucher_waitinglist_subtitle: 'Күту парағы',
    voucher_waitingList_requestFormId: 'Өтініш №',
    voucher_waitingList_voucherId: 'Ваучер №',
    voucher_waitingList_childIIN: 'Баланың ЖСН-і',
    voucher_waitingList_childFIO: 'Баланың аты-жөні',
    voucher_waitingList_childBirthday: 'Туған күні',
    voucher_waitingList_DOName: 'Ұйым атауы',
    voucher_waitingList_address: 'Мекен-жайы',
    voucher_applications_changeDDO: 'Ұйымды өзгерту',
    voucher_waitingList_enroll: 'Қабылдау',
    voucher_waitingList_interested: 'Мүдделі',
    voucher_waitingList_position: 'Кезек №',
    voucher_waitingList_deadlineDateForEnroll:'МДҰ-ға қабылдау мерзімі:',


    voucher_waitingList_errorLoad: 'Деректерді жүктеуде қателік орын алды',
    voucher_waitingList_error_add_waiting_list: 'Күту тізіміне қосу мүмкін болмады',
    voucher_waitingList_error_change_waiting_list: 'Күту тізімінді өзгерту мүмкін болмады'
  }
});
